import React from "react";
import Chart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material"
import { ApexOptions } from "apexcharts";

export type WeatherChartProps = {
    title?: string,
    series: ApexAxisChartSeries,
    hours: Array<number>,
    measureDate: Date,
    icons: Array<string>
}

const WeatherChart: React.FunctionComponent<any> = (props: WeatherChartProps) => {
    const { title, series, icons, measureDate, hours } = props;
    const theme = useTheme()
    const { t } = useTranslation();

    const formatValue = (value: string) => {
 
        let pasredValue = parseInt(value);       
        
        let dayIndex = 0;
        let day = t("common.day."+( (measureDate.getDay()+dayIndex) % 7) as string);

        hours.forEach((value, index) => {
            if(value === 0) {
                dayIndex++;
            }
            if(index === pasredValue - 1) {
                day = t("common.day."+( (measureDate.getDay()+dayIndex) % 7) as string);
            }
        });
        // If you need to add minutes as well:
        // :${measureDate.getMinutes() >= 10 ? measureDate.getMinutes() : '0' + String(measureDate.getMinutes())}
        // If you need to format hours as well:
        // ${(val - 1 + measureDate.getHours()) % 24 >= 10 ?(val - 1 + measureDate.getHours()) % 24 : '0' + String((val - 1 + measureDate.getHours()) % 24)}
        return `${day}, ${(pasredValue - 1 + measureDate.getHours()) % 24}h`;
    }

    const annotations: ApexAnnotations = {
        xaxis: Array.from(Array(hours.length).keys()).map((val: any) => {
            const formattedValue = formatValue(val + 1);
            if(formattedValue.substring(5, 7) == '0h') {
                return {
                    x: formattedValue,
                    strokeDashArray: 0,
                    marker: {
                        size: 8
                    },
                    label: {
                        style: {
                            color: theme.palette.text.primary
                        },
                        borderColor: '#005a96',
                        text: formattedValue.substring(0, 3)
                    }
                }
            } else {
                return {
                    x: null
                }
            }
        }),
        images: icons.map((val: string, index: number) => {
            return {
                x: 55+index*28.8, // how did i get these values? i have no clue. just trial and error
                y: 50,
                path: "images/icons/"+val+".svg",
                width: 20,
                height: 20,
            }
        })
    };

    const options: ApexOptions = {
        chart: {
            height: 350,
            fontFamily: "Roboto, Arial, sans-serif",
            width: "100%",
            zoom: {
                enabled: false
            },
            type: 'line',
            selection: {
                enabled:false
            },
            toolbar: {
                show: false
            }
        },
        fill: {
            colors: ['#6c9bba']
        },
        stroke: {
            show: true,
            curve: "smooth",
            width: [0, 4]
        },
        colors: ["#005a96", "#005a96", "#005a96"],
        title: {
            text: title,
            margin: 35,
        },
        dataLabels: {
            enabled: true,
            enabledOnSeries: [1]
        },
        xaxis: {
            type: 'category',
            tickPlacement: 'on',
            labels: {
                show: true,
                trim: false,
                rotate: -45,
                style: {
                    colors: theme.palette.text.primary
                },
                offsetX: 5,
                offsetY: 5,
                formatter(value, timestamp, opts) {
                    return formatValue(value);
                },
                // datetimeUTC: true,
                // datetimeFormatter: {
                //      hour: 'HH:mm',
                // },
            },
            tooltip: {
                enabled: false,
            },
            offsetX: 0,
            offsetY: 0
        },
        yaxis: [{
            opposite: true,
            /*title: {
                text: t('public.weather.pop') + '%'
            },*/
            max: 100,
            min: 0
        }, {
            title: {
                text: ""//t('public.weather.temperature') + '°C'
            }
        }],
        tooltip: {
            enabled: false, // set to true to enable tooltip div on hower
            marker: {
                show: false
            },
            y: [{
                formatter: (val: number) => {
                    return `${val}%`;
                }
            }, {
                formatter: (val: number) => {
                    return `${val}°C`;
                }
            }]
        },
        annotations: annotations,
        legend: {
            show: false, // set to true to enable legend with dots under graph
            markers: {
                width: 15,
                height: 15,
                strokeColor: '#000000',
                fillColors: ["#7FA7C1","#045D98"],
                radius: 15,
            },
        }
    }


    return (
        <Chart
            type="line"
            options={options}
            series={series}
            width="1500px"
            height="300px"
        />
    );
}
  
export default WeatherChart;